import { render } from "./FooterResults.vue?vue&type=template&id=21a7799f&scoped=true"
import script from "./FooterResults.vue?vue&type=script&lang=js"
export * from "./FooterResults.vue?vue&type=script&lang=js"

import "./FooterResults.vue?vue&type=style&index=0&id=21a7799f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a7799f"]])

export default __exports__